export default {"src":"/_next/static/media/EdTechIcon.6d625897.svg","height":70,"width":130};